        import styled from 'styled-components';

        const LDGoalsStyle = styled.section`
        margin-top: 73px;
        width: 100%;

        .deploy__desc{
        h2{
        color: #333;
        font-family: Noto Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 175%; /* 56px */
        margin-bottom: 21px;
        width: 100%;
        @media only screen and (max-width: 992px){
        font-size: 24px;
        }

        @media only screen and (max-width: 768px){
        font-size: 18px;
        }

        @media only screen and (max-width: 576px){
        font-size: 16px;
        }
        }
        p{
        color: #333;
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 175%; /* 28px */
        width: 100%;
        @media only screen and (max-width: 992px){
        font-size: 15.5px;
        }
        @media only screen and (max-width: 768px){
        font-size: 14px;
        }
        @media only screen and (max-width: 576px){
        font-size: 12px;
        }
        }
        }

        .deploy__content{
        margin-top: 32px;
        }

        .deploy__content__item{
        margin-bottom: 0;
        img{
        width: 80px;
        height: 80px;
        @media only screen and (max-width: 992px){
        width: 60px;
        height: 60px;
        }
        @media only screen and (max-width: 576px){
        width: 40px;
        height: 40px;
        }
        }
        p{
        color: var(--gray-1, #333);
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 175%; /* 28px */
        margin-top: 29px;
        text-align: center;
        width: 100%;
        span{
        font-family: Noto Sans;
        font-weight: 400;
        }
        @media only screen and (max-width: 992px){
        font-size: 15.5px;
        }
        @media only screen and (max-width: 768px){
        font-size: 14px;
        margin-top: 14px;
        margin-bottom: 24px;
        }
        @media only screen and (max-width: 576px){
        font-size: 12px;
        margin-top: 14px;
        margin-bottom: 24px;
        }
        }
        }


        `;

        export default LDGoalsStyle;
